import { useActiveBoardContext } from '../../boardv3/stores/ActiveBoardContext';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { CanvasView } from '../components/CanvasView';

export default function CanvasPage() {
  useDocumentTitle('Canvas – qtplan');
  const { boardId } = useActiveBoardContext();
  return <CanvasView boardId={boardId} />;
}
